import React, { useEffect, useState } from 'react';
import NotificationCard from '../../components/NotificationCard/NotificationCard';
import { BASE_URL, USER_URL } from '../../constant/api';
import axios from 'axios';

function SellerNotification() {
  const [notifications, setNotifications] = useState([]);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await USER_URL.get(`/orders/notifications/`)
        console.log(response);
        setNotifications(response.data.Data.reverse()); // Adjust based on your API response structure
      } catch (error) {
        console.error("Failed to fetch notifications:", error);
      }
    };

    fetchNotifications();
  }, [token]);

  return (
    <div>
      <NotificationCard notifications={notifications} />
    </div>
  );
}

export default SellerNotification;
